module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (46).5e4e3844.jpg";